export default __webpack_public_path__ + "static/media/icon_share_kakao.ab90cae0.svg";